import React from "react";

import * as S from "./styles";

const Queen: React.FC = () => {
  return (
    <S.Container>
      <S.QueenGirl
        className="wow animate__animated animate__zoomIn"
        data-wow-duration="1s"
      />
    </S.Container>
  );
};

export default Queen;
